<template>
  <div class="home">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="chart-card" shadow="hover">
          <div>
            <el-text style="font-weight: bolder;">Hi, 欢迎光临本站。</el-text>
          </div>
          <div>
            <el-text>本站唯一域名：https://www.xuesinuo.com/</el-text>
          </div>
          <div>
            <el-text>站内定期更新个人动态和项目分享。</el-text>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div class="btm">
      <el-link type="primary" href="https://beian.miit.gov.cn">冀ICP备2021001249号</el-link>
    </div>
  </div>
</template>

<script setup>
</script>

<style lang="less">
.home {
  .chart-card {
    height: calc(100vh - 125px);
  }

  .btm {
    text-align: center;
    margin-top: 10px;
  }
}
</style>